/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkMilkIcon16Solid = forwardRef('FoodDrinkMilkIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4 2h8V1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1Z" }),
        React.createElement("path", { d: "M12 3H4.902l1.875 3h7.049L12 3Z" }),
        React.createElement("path", { d: "M14 7H7v8h5a2 2 0 0 0 2-2V7Z" }),
        React.createElement("path", { d: "M6 15V6.643l-2.038-3.26-1.626 2.363A2 2 0 0 0 2 6.856V13a2 2 0 0 0 2 2h2Z" })));
});
